<nav [attr.aria-label]="quickLinksTitle">
  <div *ngIf="!isLoading; else skeleton">
    <div
      *ngIf="orgLinks.length"
      class="box guts-m-t-3 guts-p-full-2"
      data-dgat="quick-links-box"
    >
      <h4 class="h3">{{ quickLinksTitle }}</h4>
      <ul>
        <li
          *ngFor="let link of orgLinks"
          class="guts-m-t-1"
          data-dgat="quick-links-d2f"
        >
          <a
            class="par uhover l_flex color-ebony-a61 quick-link"
            href="{{ link.url }}"
            (click)="trackClick(link)"
            target="_blank"
            aria-describedby="a11yNewWindowDescription"
            data-dgat="quick-links-144"
          >
            <span class="l_flex-grow">{{ link.title }}</span>
            <df-icon size="small" icon="arrow-up-right-out"></df-icon>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<ng-template #skeleton>
  <div class="box guts-m-t-3 guts-p-full-2 skeleton-container">
    <div class="skeleton__line bg-animate grid__col-4 guts-p-full-0"></div>
    <div
      *ngFor="let i of [5, 6, 3, 4, 5]"
      class="l_flexbar guts-m-t-1-half l_flex-middle"
      data-dgat="quick-links-c77"
    >
      <div
        class="skeleton__line bg-animate grid__col-{{ i }} guts-p-full-0"
      ></div>
      <div
        class="
          skeleton__line
          bg-animate
          grid__col-1
          guts-p-full-0 guts-m-l-auto
          squared
        "
      ></div>
    </div>
  </div>
</ng-template>
